import React from "react";

const WaitingRoom = ({ onConnect }) => {
  return (
    <div className="container">
      <h1>Waiting Room</h1>
      <p>Waiting for the doctor to join the session...</p>
      <button onClick={onConnect}>Connect to Video</button>
    </div>
  );
};

export default WaitingRoom;